import React, { useState, useEffect } from 'react';
import { ChatInterface } from './components/ChatInterface';

function ChatSupport({ isOpen, onClose }) {
  const [showChat, setShowChat] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShowChat(true);
    }
  }, [isOpen]);

  const handleClose = () => {
    setShowChat(false);
    if (onClose) {
      onClose();
    }
  };

  if (!showChat) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
      <div 
        className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl h-[85vh] max-h-[800px] flex flex-col transform transition-all duration-300 ease-out scale-100 animate-fadeInUp"
        style={{
          minHeight: '600px',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.05)'
        }}
      >
        {/* Beautiful Header with Gradient */}
        <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 text-white px-8 py-6 flex items-center justify-between rounded-t-2xl">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center backdrop-blur-sm">
              <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
              </svg>
            </div>
            <div>
              <h1 className="text-2xl font-bold">Asistente de Facturas Simples</h1>
              <p className="text-blue-100 text-sm">Estoy aquí para ayudarte con todas tus consultas</p>
            </div>
          </div>
          
          <button
            onClick={handleClose}
            className="text-white hover:text-gray-200 transition-colors p-2 hover:bg-white hover:bg-opacity-10 rounded-full"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Chat Interface */}
        <div className="flex-1 flex flex-col overflow-hidden">
          <ChatInterface 
            apiBaseUrl={process.env.REACT_APP_API_BASE_URL || 'http://localhost:5272'}
            userId={process.env.REACT_APP_USER_ID || 'demo-user'}
            onClose={handleClose}
            isModal={true}
          />
        </div>
      </div>
    </div>
  );
}

export default ChatSupport;
